import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=3ebff63f&scoped=true&"
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=3ebff63f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebff63f",
  null
  
)

export default component.exports